import React, { useMemo } from 'react';
import { RoundStatus } from '@pascal/pascal-core';
import { HistoryItem } from '../historyItem';

export const FishTable = ({ data }) => {
  const { roundData, status, additionalParams } = data;

  const emptyOrResultsArr = useMemo(() => {
    const roundDataLength = roundData?.length;

    if (roundData && (status === RoundStatus.Finished || additionalParams)) {
      if (roundDataLength >= 10) {
        return roundData;
      }
      return [...roundData, ...new Array(10 - roundDataLength).fill(null)];
    }

    return new Array(10).fill(null);
  }, [additionalParams, roundData, status]);

  return (
    <div className='gatheredFishContainer'>
      <div className='gatheredFishContainerInner'>
        <ul className='fs-gathered-fish-list'>
          {emptyOrResultsArr.map((roundResult, index) => (
            <HistoryItem
              roundResult={roundResult}
              index={index}
              additionalParams={additionalParams}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};
